import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CategoryStreamService_GetProductStreamPageV2Lazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/stream/service.grpc.lazy';
import {useSrtParam} from '@aboutyou/router';
import {
  useAnySession,
  useNavigationBackOptimizedBasketToken,
} from '@aboutyou/user';
import {useAnyFilterFlyoutOpened} from '../../../features/Filters/shared/useAnyFilterFlyoutOpened';
import {
  useKeepPreviousData,
  useResetOnFetchEnd,
} from '../../../features/ProductStream/utils/useKeepPreviousData';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useProtoProductImageType} from '../../../shared-deprecated/useProductImageType';
import {useCategoryCacheKeyTransformer} from './useCategoryIdentifier';

export const useCategoryProductStreamNext = ({token}: {token: Uint8Array}) => {
  const categoryCacheKeyTransformer = useCategoryCacheKeyTransformer();
  const session = useAnySession();
  const isFilterFlyoutOpen = useAnyFilterFlyoutOpened();
  const {keepPreviousData, resetOnFetchEnd} = useKeepPreviousData();
  const {basketToken} = useNavigationBackOptimizedBasketToken({
    uniqueKey: 'category_stream',
  });
  const sortingChannel = useSrtParam();

  const preferredImage = useProtoProductImageType();

  const request = useGrpcRequest(
    CategoryStreamService_GetProductStreamPageV2Lazy,
    {
      session,
      // The below values are unintended but are provided as defaults to make the request work. Otherwise the runtime throws an error.

      reductionsState: useReductionsStateRequestParameter(),
      basketToken,
      preferredProductImageType: preferredImage,
      streamState: token,
      sortingChannel,
    },
    {
      retry: 1,

      disabled: isFilterFlyoutOpen,
      transformCacheKey: categoryCacheKeyTransformer,
      keepPreviousData,
    },
  );

  useResetOnFetchEnd(request, resetOnFetchEnd);

  return request;
};
